<template>
  <v-card outlined style="margin-bottom: 24px">
    <UpdateLeadExtra ref="update-dialog" @refresh="() => $emit('refresh')" />
    <div class="d-flex justify-space-between align-items-center py-6 pl-6">
      <h5 class="text-uppercase align-self-center">Thông tin học sinh</h5>
      <v-btn
        text
        color="blue darken-4"
        class="pr-6 document-btn no-hover"
        plain
        @click="() => $refs['update-dialog'].open()"
        style="height: 18px"
        v-if="authorized"
      >
        <v-icon left>mdi-playlist-edit</v-icon>
        Cập nhật
      </v-btn>
    </div>

    <v-row class="px-6 pb-6" no-gutters>
      <v-col cols="4">
        <p class="grey--text my-0">Tên học sinh</p>
        <p class="my-0">{{ $_get(profile, 'studentName', '-') }}</p>
      </v-col>
      <v-col cols="4">
        <p class="grey--text my-0">Ngày sinh</p>
        <p class="my-0">{{ $_get(profile, 'studentDob', '-') }}</p>
      </v-col>
      <v-col cols="4">
        <p class="grey--text my-0">Trường</p>
        <p class="my-0">{{ $_get(profile, 'studentSchool', '-') }}</p>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import UpdateLeadExtra from '@/components/basic/form/UpdateLeadExtra.vue'
import { mapGetters } from 'vuex'

export default {
  props: { authorized: Boolean },
  components: { UpdateLeadExtra },
  computed: { ...mapGetters({ profile: 'lead/item' }) },
}
</script>

<style>
.no-hover.v-btn--plain .v-btn__content {
  opacity: 1 !important;
}
</style>
